import React, { useState, useEffect } from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";
import Image from "react-bootstrap/Image";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbDivider, BreadcrumbSection, Dimmer, Loader } from "semantic-ui-react";
import { HtmlRenderer } from "../../component/utility";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import SeoHelmet from '../../component/SeoHelmet';
import { useMyGlobal } from '../../component/GlobalData';

export const BlogPage = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [article, setArticle] = useState([])
    const params = useParams()
    const [loadData, setLoadData] = useState(false)
    const { isPortrait, windowWidth } = useMyGlobal()

    const pathSegments = location.pathname
        .split('/')
        .filter(segment => segment && isNaN(Number(segment)))
        .map(segment => decodeURIComponent(segment.replace(/-/g, ' ')))

    const handleRouteTo = (data) => {
        navigate(`/news_and_article`)
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        const getArticleData = async (slug) => {
            setLoadData(true)
            const url = process.env.REACT_APP_BLOG_URL
            await axios({
                method: "GET",
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                },
                params: {
                    slug: slug
                }
            }).then(res => {
                if (res.data.state === 200) {
                    let data = res.data.data
                    const formattedDate = new Date(data.created_at).toLocaleDateString('en-US', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                    });
                    data.formatted_time = formattedDate
                    setArticle(data)
                    document.title = res.data.data.title
                } else {
                    alert(res.data.message)
                }
            }).finally(() => setLoadData(false))
        }

        if (params) {
            getArticleData(params.title)
        } else {
            getArticleData(location.state.slug)
        }
    }, [])

    return (
        <>
            <SeoHelmet
                title={article.title}
                description={article.meta_description}
            />
                
            <section style={{marginTop: windowWidth < 1000 ? "12vh" : "18vh"}}>
                <Container>
                    <Dimmer active={loadData} inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                    <Row className="mb-5">
                        <Col xl={10} lg={12} md={12} sm={12} className="text-start">
                            <Breadcrumb size="tiny">
                                <BreadcrumbSection link onClick={() => navigate(`/`)}>HOME</BreadcrumbSection>
                                <BreadcrumbDivider />
                                {pathSegments?.slice(0, -1).map((p, i) => (
                                    <React.Fragment key={i}>
                                        <BreadcrumbSection className="text-uppercase" onClick={() => handleRouteTo(p)}>{p}</BreadcrumbSection>
                                        <BreadcrumbDivider />
                                    </React.Fragment>
                                ))}
                                <BreadcrumbSection active className="text-uppercase">{article.title}</BreadcrumbSection>
                            </Breadcrumb>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center">
                        {/* <Col xl={10} lg={12} md={12} sm={12} className="mb-4">
                            <Image src={article.image_content} fluid rounded />
                        </Col> */}
                        <Col xl={10} lg={12} md={12} sm={12} className="mb-5">
                            <h1>{article.title}</h1>
                        </Col>
                        <Col xl={10} lg={12} md={12} sm={12} className="mb-1 text-start">
                            <h6 className="fs-">{article.formatted_time}</h6>
                        </Col>
                        <Col xl={10} lg={12} md={12} sm={12} xs={12} className="mb-4 text-start">
                            <div className="quill-content">
                                <HtmlRenderer htmlContent={article.description} />
                            </div>
                            {/* <ReactQuill
                                className="p text-body"
                                value={article.description}
                                readOnly={true}
                                theme="bubble"
                            /> */}
                        </Col>
                        <Col xl={10} lg={12} md={12} sm={12} className="mb-4 text-start">
                            <span>Author: </span>
                            <span className="me-3 text-muted">{article.author}</span>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}